import {composeReducers, createReducerFunction} from 'immer-reducer'
import defaultState from 'redux/auth/state'
import Auth from 'redux/auth/auth.duck'

export default composeReducers(
  createReducerFunction(Auth, defaultState)
)
